var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 91,
    viewBox: "0 0 68 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.8623,
    y: -5,
    width: 25,
    height: 145,
    rx: 12.5,
    transform: "rotate(39.8238 87.8623 -5)",
    fill: "#3F78E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBlue);
export default __webpack_public_path__ + "static/media/RightBlue.a6b7445fedbb6284f7d4c20023c0dac5.svg";
export { ForwardRef as ReactComponent };